import { Selector, SelectorTarget } from "./types"
import type { OutDesignNode } from "../ast"
import type { Attr } from "../pandoc"

export function selectorTargetFromElement(node: OutDesignNode): SelectorTarget {
    const type = node.type
    let attr: Attr | undefined = node.attr
    
    if (!attr) {
        return {
            type,
            classes: []
        }
    }
    
    const [id, classes] = [attr[0], attr[1]]
    
    return {
        type,
        id,
        classes
    }
}


export function parseSelectorList(sel: string): Selector[] {
    if (!sel || typeof sel !== "string") {
        return [];
    }

    const selectors: Selector[] = [];
    const parts = sel.split(",");
    
    for (const part of parts) {
        
        const trimmed = part.trim();
        const selector = parseSelector(trimmed);
        
        selectors.push({
            ...selector,
            raw: trimmed
        });
    }
    
    return selectors;
}

export function parseSelector(sel: string): Selector {
    let raw: string = sel;
    let type: string | undefined;
    let id: string | undefined;
    const classes: string[] = [];

    if (sel === "") return {};
    
    const tokens = sel.split(/(?=[.#])/);
    
    for (const token of tokens) {
        if (token.startsWith(".")) {
            classes.push(token.slice(1));
        }
        
        else if (token.startsWith("#")) {
            id = token.slice(1);
        }
        
        else {
            type = token;
        }
    }
    
    const selector: Selector = { raw, type, id, classes };
    
    return selector;
}

export function selectorsToString(selectors: Array<Selector>): string {
    let arr : string[] = [];
    selectors.forEach((sel) => { arr.push(selectorToString(sel)) } );
    return arr.join(", ")
}

function selectorToString(sel: Selector): string {
    if (typeof sel === undefined) return "";
    let s: Array<string> = [];
    if(sel.type) s.push(sel.type as string)
    if(sel.id) s.push(`#${sel.id}`);
    if(sel.classes) s.push(`.${sel.classes.join(".")}`);
    return s.join(" ");
}

export function isMatchingSelector(
    node: OutDesignNode,
    selector: Selector
): boolean {
    
    const target = selectorTargetFromElement(node)
    
    if (selector.type && selector.type !== target.type) {
        return false
    }
    
    if (selector.id && selector.id !== target.id) {
        return false
    }
    
    if (selector.classes) {
        for (const cls of selector.classes) {
            if (!target.classes.includes(cls)) {
                return false
            }
        }
    }
    
    return true
}

export function isMatchingSelectorList(
    node: OutDesignNode,
    selectors: Selector[]
): Selector | false {
    
    if (!node) return node;

    for (const selector of selectors) {
        if (isMatchingSelector(node, selector)) {
            return selector
        }
    }
    
    return false
}